import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, MenuItem } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"
import Save from "@mui/icons-material/Save"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const CrearTiposdeCompromiso = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  // Estado inicial del formulario adaptado a cxcbtipocompromiso
  const [formData, setFormData] = useState({
    tipocompromiso: "",
    tipocomdescri: "",
    tipcomstatus: "A",
  })

  // Hook de mutación estandarizado
  const { mutateAsync: SaveNuevoCompromiso, isPending: isSaving } = useMutation({
    queryKey: ["isCreatingTipoCompromiso"],
    fn: async (data) => {
      const response = await api.post("/TiposdeCompromiso/createTiposdeCompromiso", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  // Manejador de cambios con validación de longitud (respetando los varchars de la tabla)
  const handleInputChange = (field, value) => {
    let finalValue = value

    if (field === "tipocompromiso") {
      finalValue = value.toUpperCase().slice(0, 15) // varchar(15)
    } else if (field === "tipocomdescri") {
      finalValue = value.toUpperCase().slice(0, 60) // varchar(60)
    }

    setFormData((prev) => ({ ...prev, [field]: finalValue }))
  }

  // Validación previa al envío
  const handleSubmit = async (e) => {
    if (e) e.preventDefault()
    try {
      if (!formData.tipocompromiso.trim()) {
        showWarning("El código de compromiso es obligatorio")
        return
      }
      if (!formData.tipocomdescri.trim()) {
        showWarning("La descripción es obligatoria")
        return
      }

      await SaveNuevoCompromiso(formData)
    } catch (error) {
      console.error("Error al crear el Tipo de Compromiso:", error)
    }
  }

  // Buscamos las acciones permitidas (GRABAR, CREAR o EJECUTAR)
  const action = selectedMenuInfo?.data?.barraAcciones?.find(
    (a) => a?.acccaption === "GRABAR" || a?.acccaption === "CREAR" || a?.acccaption === "EJECUTAR",
  )

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* Barra de Herramientas */}
        <Box sx={{ mb: 2 }}>
          <Tooltip title={action?.acccaption || "Grabar"}>
            <IconButton
              onClick={handleSubmit}
              disabled={isSaving}
              sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, bgcolor: "white" }}
            >
              {action ? getIconComponent(action.accnameicono, action.acctipoico) : <Save />}
            </IconButton>
          </Tooltip>
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Tipo de Compromiso</b>
        </div>

        <CustomBackdrop isLoading={isSaving} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 3, mb: 3, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Código *"
                  value={formData.tipocompromiso}
                  onChange={(e) => handleInputChange("tipocompromiso", e.target.value)}
                  placeholder="Ej: COMP-01"
                />
              </Grid>

              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  label="Descripción *"
                  value={formData.tipocomdescri}
                  onChange={(e) => handleInputChange("tipocomdescri", e.target.value)}
                  placeholder="Ej: ACUERDO DE PAGO PARCIAL"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Estado"
                  value={formData.tipcomstatus}
                  onChange={(e) => handleInputChange("tipcomstatus", e.target.value)}
                >
                  <MenuItem value="A">ACTIVO</MenuItem>
                  <MenuItem value="I">INACTIVO</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CrearTiposdeCompromiso
